












































































































import _ from "lodash";
import { MaterielApi } from "../api/MaterielApi";
import { ListParamApi } from "../api/ListParamApi";
import { Option } from "../models/Option";
import { EquipementMateriel } from "../models/Materiel";
import EquipementCard from "./EquipementCard.vue";
import EquipementEditModal from "./EquipementEditModal.vue";
import EquipementDetailModal from "./EquipementDetailModal.vue";

export default {
    name: "InventairePanel",
    components: {
        EquipementCard,
        EquipementEditModal,
        EquipementDetailModal,
    },
    props: {
        refreshKey: Number,
    },
    data() {
        return {
            MaterielApi: new MaterielApi(),
            ListParamApi: new ListParamApi(),
            equipements: [],
            categories: [],
            loading: false,
            search: "",
            catFilter: "",
            statutFilter: "",
            showArchived: false,
            showEditModal: false,
            showDetailModal: false,
            selectedEquipement: null,
        };
    },
    computed: {
        actifs: function () {
            return _.filter(this.equipements, function (eq) {
                return !eq.archived;
            });
        },
        archivedCount: function () {
            return _.filter(this.equipements, function (eq) {
                return !!eq.archived;
            }).length;
        },
        stats: function () {
            let sortis = _.filter(this.actifs, function (eq) {
                return eq.is_sorti;
            }).length;
            return {
                total: this.actifs.length,
                sortis: sortis,
                disponibles: this.actifs.length - sortis,
            };
        },
        items: function () {
            let self = this;
            let list = self.showArchived
                ? self.equipements.slice()
                : self.actifs.slice();

            if (self.catFilter) {
                list = _.filter(list, function (eq) {
                    return eq.categorie_id === parseInt(self.catFilter, 10);
                });
            }

            if (self.statutFilter) {
                list = _.filter(list, function (eq) {
                    return eq.statut === self.statutFilter;
                });
            }

            if (self.search) {
                let q = self.search.toLowerCase();
                list = _.filter(list, function (eq) {
                    let haystack =
                        eq.libelle +
                        " " +
                        (eq.modele || "") +
                        " " +
                        (eq.numero_serie || "") +
                        " " +
                        (eq.code_barre || "") +
                        " " +
                        (eq.emplacement_nom || "");
                    return haystack.toLowerCase().indexOf(q) !== -1;
                });
            }

            return list.sort(function (a, b) {
                return (
                    (a.categorie_nom || "") +
                    _.padStart(String(a.numero || 0), 4, "0")
                ).localeCompare(
                    (b.categorie_nom || "") +
                        _.padStart(String(b.numero || 0), 4, "0")
                );
            });
        },
    },
    created() {
        this.loadCategories();
        this.load();
    },
    methods: {
        openEtiquettes: function () {
            let self = this;
            let ids = _.map(self.items, function (eq) {
                return eq.id;
            });
            if (!ids.length) {
                return;
            }
            self.MaterielApi.openInNewTab(
                self.MaterielApi.etiquettesPdfUrl(ids)
            ).catch(function (error) {
                self.emitError(error);
            });
        },
        load: function () {
            let self = this;
            self.loading = true;
            // On charge actifs + archivés en une fois : le partage se fait
            // ensuite côté client (bouton « Voir les archivés »).
            self.MaterielApi.getEquipements({ archived: "all" })
                .then(function (res) {
                    self.equipements = res;
                    self.loading = false;
                    self.rafraichirSelection();
                })
                .catch(function (error) {
                    self.loading = false;
                    self.emitError(error);
                });
        },
        loadCategories: function () {
            let self = this;
            self.ListParamApi.getAll({
                type: Option.EListParamType.materiel_categorie,
            })
                .then(function (res) {
                    self.categories = res;
                })
                .catch(function () {
                    self.categories = [];
                });
        },
        /** Ré-aligne l'équipement affiché dans les modales sur la liste rechargée. */
        rafraichirSelection: function () {
            if (!this.selectedEquipement || !this.selectedEquipement.id) {
                return;
            }
            let found = _.find(this.equipements, {
                id: this.selectedEquipement.id,
            });
            if (found) {
                this.selectedEquipement = found;
            }
        },
        openNouveau: function () {
            this.selectedEquipement = new EquipementMateriel();
            this.showEditModal = true;
        },
        openEdition: function (equipement) {
            this.selectedEquipement = equipement;
            this.showEditModal = true;
        },
        openDetail: function (equipement) {
            this.selectedEquipement = equipement;
            this.showDetailModal = true;
        },
        editDepuisDetail: function () {
            this.showDetailModal = false;
            this.showEditModal = true;
        },
        onSaved: function () {
            this.showEditModal = false;
            this.load();
            this.$emit("refresh");
        },
        onRefreshDemande: function () {
            this.load();
            this.$emit("refresh");
        },
        emitError: function (error) {
            this.$emit("toast", {
                message: _.get(
                    error,
                    "response.data.message",
                    "Une erreur est survenue"
                ),
                kind: "error",
            });
        },
    },
    watch: {
        refreshKey: function () {
            this.load();
        },
    },
};
